export class HistoriesModel {
    histories: HistoryModel[]
    suggestions: SuggestionsModel[]
    prescriptions: PrescriptionsModel[]
}

export class HistoryModel {
    history_sequence: string
    sup_sequence: string
    link_no: string
    link_type: string
    cost: string
    ddate: string
    done_date: string
    inv_date: string
    unit: string
    req_by: string
    req_employee_initial: string
    appr_by: string
    done_employee_initial: string
    inv_by: string
    inv_employee_initial: string
    response1: string
    response2: string
    display: string
    route: string
    clinic_abbrev: string
    location: string
    invoice_no: string
    procedure_desc: string
    code_name: string
    code_category: string
    code_sub_category: string
    category_name: string
    subcategory_name: string
    ticks_done_date: number
    ticks_inv_date: number

    constructor(
        history_sequence: string,
        sup_sequence: string,
        link_no: string,
        link_type: string,
        cost: string,
        ddate: string,
        done_date: string,
        inv_date: string,
        unit: string,
        req_by: string,
        req_employee_initial: string,
        appr_by: string,
        done_employee_initial: string,
        inv_by: string,
        inv_employee_initial: string,
        response1: string,
        response2: string,
        display: string,
        route: string,
        clinic_abbrev: string,
        location: string,
        invoice_no: string,
        procedure_desc: string,
        code_name: string,
        code_category: string,
        code_sub_category: string,
        category_name: string,
        subcategory_name: string,
        ticks_done_date: number,
        ticks_inv_date: number
    ) {
        this.history_sequence = history_sequence
        this.sup_sequence = sup_sequence
        this.link_no = link_no
        this.link_type = link_type
        this.cost = cost
        this.ddate = ddate
        this.done_date = done_date
        this.inv_date = inv_date
        this.unit = unit
        this.req_by = req_by
        this.req_employee_initial = req_employee_initial
        this.appr_by = appr_by
        this.done_employee_initial = done_employee_initial
        this.inv_by = inv_by
        this.inv_employee_initial = inv_employee_initial
        this.response1 = response1
        this.response2 = response2
        this.display = display
        this.route = route
        this.clinic_abbrev = clinic_abbrev
        this.location = location
        this.invoice_no = invoice_no
        this.procedure_desc = procedure_desc
        this.code_name = code_name
        this.code_category = code_category
        this.code_sub_category = code_sub_category
        this.category_name = category_name
        this.subcategory_name = subcategory_name
        this.ticks_done_date = ticks_done_date
        this.ticks_inv_date = ticks_inv_date
    }
}

export class SuggestionsModel {
    suggest_date: string
    link_no: string
    link_type: string
    procedure_desc: string

    constructor(
        suggest_date: string,
        link_no: string,
        link_type: string,
        procedure_desc: string
    ) {
        this.suggest_date = suggest_date
        this.link_no = link_no
        this.link_type = link_type
        this.procedure_desc = procedure_desc
    }
}

export class PrescriptionsModel {
    drug_note_date: string
    product_name: string
    employee_initial: string
    units: string
    package: string
    refill_count: string
    refill_expire: string
    allow_generic: string
    in_clinic: string
    instructions: string
    drug_note_sequence: string
    use_for: string
    ticks_drug_note_date: number

    constructor(
        drug_note_date: string,
        product_name: string,
        employee_initial: string,
        units: string,
        _package: string,
        refill_count: string,
        refill_expire: string,
        allow_generic: string,
        in_clinic: string,
        instructions: string,
        drug_note_sequence: string,
        use_for: string,
        ticks_drug_note_date: number
    ) {
        this.drug_note_date = drug_note_date
        this.product_name = product_name
        this.employee_initial = employee_initial
        this.units = units
        this.package = _package
        this.refill_count = refill_count
        this.refill_expire = refill_expire
        this.allow_generic = allow_generic
        this.in_clinic = in_clinic
        this.instructions = instructions
        this.drug_note_sequence = drug_note_sequence
        this.use_for = use_for
        this.ticks_drug_note_date = ticks_drug_note_date
    }
}